import React from "react";
import CaseDetailsModal from "../../../../components/CaseDetailsModal";

// ใช้ modal รายละเอียดตัวกลาง — แก้หน้าตา/ข้อมูลที่ components/CaseDetailsModal.jsx ที่เดียว
const DetailsModal = ({ visible, onClose, record }) => (
  <CaseDetailsModal open={visible} onClose={onClose} caseId={record?.id} record={record} />
);

export default DetailsModal;
